import { CoverageCheckupState } from '../../../store/step';
import RadioTile from '@ramsey-design-system/radio-tile';
import { Field, useFormikContext } from 'formik';
import { FormikFormMultiField } from '../../shared/FormikFormMultiField';
import React, { ReactElement } from 'react';

interface LifeInsuranceTypeStepFormProps {
  name: keyof CoverageCheckupState;
}

function LifeInsuranceTypeStepForm({
  name,
}: LifeInsuranceTypeStepFormProps): ReactElement {
  const { values } = useFormikContext<CoverageCheckupState>();
  return (
    <FormikFormMultiField<CoverageCheckupState> name={name} as="fieldset">
      <div>
        <Field
          className="rds-RadioTile--sm mb-2 max-w-[300px]"
          as={RadioTile}
          name={name}
          label="Term life insurance"
          value="term"
          data-testid="term"
          checked={values[name] === 'term'}
        />
        <Field
          className="rds-RadioTile--sm mb-2 max-w-[300px]"
          as={RadioTile}
          name={name}
          label="Cash value life insurance"
          value="cash_value"
          data-testid="cash_value"
          checked={values[name] === 'cash_value'}
        />
        <Field
          className="rds-RadioTile--sm mb-2 max-w-[300px]"
          as={RadioTile}
          name={name}
          label="I'm not sure"
          value="not_sure"
          data-testid="not_sure"
          checked={values[name] === 'not_sure'}
        />
      </div>
    </FormikFormMultiField>
  );
}

export { LifeInsuranceTypeStepForm };
